/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_price = /** @type {(inputs: {}) => string} */ () => {
	return `Ceny`
};

const da_attributes_price = /** @type {(inputs: {}) => string} */ () => {
	return `Pris`
};

const de_attributes_price = /** @type {(inputs: {}) => string} */ () => {
	return `Preis`
};

const en_attributes_price = /** @type {(inputs: {}) => string} */ () => {
	return `Price`
};

const es_attributes_price = /** @type {(inputs: {}) => string} */ () => {
	return `Precio`
};

const fr_attributes_price = /** @type {(inputs: {}) => string} */ () => {
	return `Prix`
};

const hu_attributes_price = /** @type {(inputs: {}) => string} */ () => {
	return `Ár`
};

const it_attributes_price = /** @type {(inputs: {}) => string} */ () => {
	return `Prezzo`
};

const nl_attributes_price = /** @type {(inputs: {}) => string} */ () => {
	return `Prijs`
};

const pl_attributes_price = /** @type {(inputs: {}) => string} */ () => {
	return `Cena`
};

const pt_attributes_price = /** @type {(inputs: {}) => string} */ () => {
	return `Preço`
};

const sv_attributes_price = /** @type {(inputs: {}) => string} */ () => {
	return `Pris`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_price = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_price(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_price", locale)
	if (locale === "cs") return cs_attributes_price(inputs)
	if (locale === "da") return da_attributes_price(inputs)
	if (locale === "de") return de_attributes_price(inputs)
	if (locale === "en") return en_attributes_price(inputs)
	if (locale === "es") return es_attributes_price(inputs)
	if (locale === "fr") return fr_attributes_price(inputs)
	if (locale === "hu") return hu_attributes_price(inputs)
	if (locale === "it") return it_attributes_price(inputs)
	if (locale === "nl") return nl_attributes_price(inputs)
	if (locale === "pl") return pl_attributes_price(inputs)
	if (locale === "pt") return pt_attributes_price(inputs)
	return sv_attributes_price(inputs)
};
export { attributes_price as "attributes.price" }